import EvtEmitter from '../libs/event-emitter';
import { PRELOAD_EVENT } from '../enums';
/**
 * 提供给kernel往外派发自定义事件，例如hls内核派发跟thls.js相关的事件出去。
 */
export var kernelEvtBus = new EvtEmitter();
/**
 * 预加载过程中，内核派发给播放器上层的事件对象
 */
export var preloadEvtBus = new EvtEmitter();
